module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/_branch-details/_branch-details.component.css
// module id = ./src/app/sendMoney/_branch-details/_branch-details.component.css
// module chunks = main